import { createFileRoute, redirect } from '@tanstack/react-router';

import { CRADL_ORGANIZATION, EXTERNAL_ORG_ID_CLAIM } from '@/constants';
import { withRequiredClaims } from '@/features/auth';

export const Route = createFileRoute('/')({
  beforeLoad: async ({ context }) => {
    const { auth } = context;

    if (auth.isAuthenticated) {
      const claims = await withRequiredClaims(auth);
      if (claims) {
        if (claims[EXTERNAL_ORG_ID_CLAIM] !== CRADL_ORGANIZATION) {
          throw redirect({ to: '/agents' });
        } else {
          throw redirect({ to: '/organizations' });
        }
      }
    }

    throw redirect({ to: '/login' });
  },
});
